import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { SelectionSingleType } from '../types';
import css from './Breadcrumbs.scss';

type Props = {
	selection: SelectionSingleType;
};

const getParents = (selection: SelectionSingleType) =>
	selection.editableModeProps.inheritance?.parent.slice(-3).filter(parent => Number.isNaN(+parent.path)) || [];

const Breadcrumbs = (props: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleIsOpen = () => setIsOpen(v => !v);

	useEffect(
		function closeOnSelectionChange() {
			setIsOpen(false);
		},
		[props.selection.id]
	);

	return (
		<div className={cn(css.breadcrumbs, { [css.open]: isOpen })} onClick={toggleIsOpen}>
			{isOpen
				? getParents(props.selection)
						.reverse()
						.map((parent, index) => (
							<div
								className={css.crumb}
								key={`crumb-parent-${parent.path}`}
								onClick={() => {
									try {
										const selected = document.getElementById(props.selection.id)!;
										const clicked = selected.closest(`[data-path="${parent.path}"]`)!;

										clicked.dispatchEvent(
											new MouseEvent('mousedown', {
												bubbles: true,
												metaKey: true,
												ctrlKey: true,
											})
										);
									} catch (e) {
										console.error((e as any).message);
									}
								}}
							>
								{parent.name}
							</div>
						))
				: null}
			<div className={cn(css.crumb, css.crumbCurrent)}>{props.selection.uiConfig.editorProps.name}</div>
		</div>
	);
};

export default Breadcrumbs;
